import { render, staticRenderFns } from "./patientsPortalSummary.vue?vue&type=template&id=0af956d9&"
import script from "./patientsPortalSummary.vue?vue&type=script&lang=js&"
export * from "./patientsPortalSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports